/**
 * 确认对话框组件
 */

import React, { useCallback, useEffect } from 'react';
import { useChatStore } from '@/stores';

interface ConfirmationDialogProps {
  onConfirm: (interruptId: string) => void;
  onReject: (interruptId: string) => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ onConfirm, onReject }) => {
  const { confirmation, hideConfirmation } = useChatStore();
  
  // ESC 键拒绝
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && confirmation) {
        onReject(confirmation.interruptId);
        hideConfirmation();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [confirmation, onReject, hideConfirmation]);
  
  // 确认
  const handleConfirm = useCallback(() => {
    if (confirmation) {
      onConfirm(confirmation.interruptId);
      hideConfirmation();
    }
  }, [confirmation, onConfirm, hideConfirmation]);
  
  // 拒绝
  const handleReject = useCallback(() => {
    if (confirmation) {
      onReject(confirmation.interruptId);
      hideConfirmation();
    }
  }, [confirmation, onReject, hideConfirmation]);
  
  if (!confirmation) return null;
  
  // 级别样式
  const levelClass = confirmation.level === 'HIGH' 
    ? 'confirmation-high' 
    : confirmation.level === 'MEDIUM' 
      ? 'confirmation-medium' 
      : 'confirmation-low';
  
  const levelText = confirmation.level === 'HIGH' 
    ? '高危' 
    : confirmation.level === 'MEDIUM' 
      ? '需确认' 
      : '提示';
  
  return (
    <div className="sse-confirmation-overlay">
      <div className={`sse-confirmation-dialog ${levelClass}`}>
        <div className="confirmation-header">
          <span className="confirmation-level">{levelText}</span>
        </div>
        <div className="confirmation-body">
          <div className="confirmation-reason">{confirmation.reason || '需要确认'}</div>
          <div className="confirmation-command">
            <code>{confirmation.command}</code>
          </div>
        </div>
        <div className="confirmation-actions">
          <button className="confirmation-btn confirm" onClick={handleConfirm}>
            确认
          </button>
          <button className="confirmation-btn cancel" onClick={handleReject}>
            拒绝
          </button>
        </div>
      </div>
    </div>
  );
};